// based on https://github.com/dmnd/dedent/blob/main/src/dedent.ts
export function dedent(strings: TemplateStringsArray, ...values: unknown[]) {
  let result = '' // interpolation
  for (let i = 0; i < strings.length; i++) {
    result += strings[i]
    if (i < values.length) {
      let value = String(values[i])
      let currentOffset = 0
      if (value.includes('\n')) {
        for (let i = result.length - 1; i >= 0; i--) {
          if (result[i] === ' ') {
            currentOffset++
          } else break
        }
        value = value.replaceAll('\n', `\n${' '.repeat(currentOffset)}`)
      }
      result += value
    }
  }

  return _dedent(result)
}

export function _dedent(string: string) {
  const lines = string.split('\n')

  let minIndent = Number.POSITIVE_INFINITY
  for (const line of lines) {
    if (line.trim() === '') continue
    const match = line.match(/^(\s+)\S+/u)
    minIndent = match ? Math.min(minIndent, match[1].length) : 0
  }

  if (minIndent !== Number.POSITIVE_INFINITY) {
    return lines
      .map((l) => (l[0] === ' ' ? l.slice(minIndent) : l))
      .join('\n')
      .trim()
  }

  return string
}
